import { ref } from 'vue';
import { debounce } from 'lodash-es';
import type { MappedCity } from '../../shared/types';

function useCitiesSearch(
  fetchCities: (query: string) => Promise<MappedCity[]>,
) {
  const isLoading = ref(false);
  const isClean = ref(false);
  const isEmptyResults = ref(false);
  const cities = ref([] as MappedCity[]);
  const query = ref('');

  const fetch = (query: string) =>
    fetchCities(query)
      .then(results => {
        if (isClean.value) {
          return [];
        }
        cities.value = results;
        isEmptyResults.value = cities.value.length === 0;
      })
      .finally(() => (isLoading.value = false));

  const debounceCitySearch = debounce(fetch, 300);

  const searchCities = (query: string) => {
    isClean.value = false;
    isLoading.value = true;
    isEmptyResults.value = false;
    debounceCitySearch(query);
  };

  const clearCities = () => {
    cities.value = [];
    isClean.value = true;
    isEmptyResults.value = false;
  };

  const setNewQuery = (newQuery: string) => (query.value = newQuery);

  return {
    cities,
    isLoading,
    isEmptyResults,
    searchCities,
    clearCities,
    query,
    setNewQuery,
  };
}

export const searchCitiesModel = {
  useCitiesSearch,
};
